import Icons from '@/const/icons';

export const handleSetMobileScreenHeader = (
	pathname: string,
	setMobileScreenHeader: (
		value: React.SetStateAction<
			| {
					icon: Icons;
					screenName: string;
			  }
			| undefined
		>
	) => void
): void => {
	if (pathname.startsWith('/lawyerapp/cases')) {
		setMobileScreenHeader({
			icon: Icons.suitcaseThick,
			screenName: 'Cases',
		});
		return;
	}
	switch (pathname) {
		case '/lawyerapp/dashboard':
			setMobileScreenHeader({
				icon: Icons.dashboard,
				screenName: 'Dashboard',
			});
			break;

		case '/lawyerapp/cases':
			setMobileScreenHeader({
				icon: Icons.suitcaseThick,
				screenName: 'Cases',
			});
			break;

		default:
			setMobileScreenHeader(undefined);
			break;
	}
};
